import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VolunteerCategory } from 'src/app/core/models/volunteer.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { VolunteerService } from 'src/app/core/services/volunteer.service';

@Component({
  selector: 'app-volunteer-role-type',
  templateUrl: './volunteer-role-type.component.html',
  styleUrls: ['./volunteer-role-type.component.scss']
})
export class VolunteerRoleTypeComponent implements OnInit {

  volunteerRoleTypes = [];
  volunteerCategory = new VolunteerCategory();

  allVolunteerRoleTypes = [];
  volunteerCategories = [];

  volunteerCategoryId: string;
  constructor(private volunteerService: VolunteerService,
    private loadingService: LoadingService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    if (this.route.snapshot.params.id) {

      this.volunteerService.getVolunteerCategoryById(this.route.snapshot.params.id).subscribe(response => {
        if (response.success){
          this.volunteerCategory = response;
          this.getVolunteerTypes(this.volunteerCategory.id);
        }
      });      
    } else{
      this.router.navigate(['/volunteer-categories']);
    }
    this.getAllVolunteerRoleTypes();
    this.getVolunteerCategories();
  }

  getVolunteerTypes(id: string){
    this.volunteerService.getVolunteerTypes(id).subscribe(response => {
      if (response.success) {
        this.volunteerRoleTypes = response.volunteerRoleTypes;
        console.log(this.volunteerRoleTypes);
      }
    })
  }

  getAllVolunteerRoleTypes(){
    this.loadingService.setLoading(true);
    this.volunteerService.getAllVolunteerTypes().subscribe(response => {
      if (response.success) {
        this.allVolunteerRoleTypes = response.volunteerRoleTypes;
        console.log(this.allVolunteerRoleTypes);
        this.loadingService.setLoading(false);
      }
    })
  }

  getVolunteerCategories(){
    this.loadingService.setLoading(true);
    this.volunteerService.getVolunteerCategories().subscribe(response => {
      if (response.success) {
        this.volunteerCategories = response.volunteerCategories;
        console.log(this.volunteerCategories);
        this.loadingService.setLoading(false);
      }
    })
  }

  deleteVolunteerRoleType(id: string, name: string) {
    const x = confirm(name + ' isimli gönüllü rolünü silmek istediğinize emin misiniz?');
    if (x) {
      this.volunteerService.deleteVolunteerRoleType(id).subscribe(response => {
        if (response.success) {
          this.getVolunteerTypes(this.volunteerCategory.id);
          this.alertService.alert("Başarılı!", "Gönüllü rolü silindi!", "success");
        } else {
          this.alertService.alert("Hata!", "Gönüllü rolü silinemedi!", "error");
        }
      })
    }
  }

  getVolunteerCategoryName(id: string){
    if (id === undefined || id === null) {
      return "-";
    }
    let value = this.volunteerCategories.filter(x => x.id === id);

    if (value !== undefined && value !== null) {
      try{
        return value[0].name;
      }
      catch {
        return "-";
      }
    }
  }

  getMainRoleName(id: string){
    if (id === undefined || id === null) {
      return "-";
    }
    let value = this.volunteerRoleTypes.filter(x => x.id === id);

    if (value !== undefined && value !== null) {
      try{
        return value[0].name;
      }
      catch {
        return "-";
      }
    }
  }
}
